// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { Box } from '@mui/material';
import LayerListItem from '../LayerListItem';

interface ParentLayerItemProps {
  items: IDeliverable[];
  activeOrder: any;
  ugAlaCarteBoolean: boolean;
  onAddOnsClick: (selectedList: { item: IDeliverable, checked: boolean, typeFactor3D?:boolean }[]) => void;
  isUnavailable: (item: IDeliverable) => boolean;
}

const ParentLayerItem = ({ items, activeOrder, ugAlaCarteBoolean, onAddOnsClick, isUnavailable }: ParentLayerItemProps) => (
  <Box>
    {items.map((item) => (
      <LayerListItem
        key={item._id}
        item={item}
        activeOrder={activeOrder}
        ugAlaCarteBoolean={ugAlaCarteBoolean}
        onAddOnsClick={onAddOnsClick}
        isUnavailable={isUnavailable(item)}
      />
    ))}
  </Box>
);

export default ParentLayerItem;
